import utils from 'utils';

export const FooterCopyright = () => {
    // todo: move to static config
    const data = {
        copyright: 'Copyright © ' + (new Date()).getFullYear() + ' ČEMAT trading, spol. s r.o.',
        designedBy: 'Designed by ACMARK s.r.o.',
    };

    return <div className={cmpClass}>
        <div className={classMap.container}>
            <span>{data.copyright}</span>
            <a href="https://coripo.cz" target="_blank" rel="noopener noreferrer">
                <span>{data.designedBy}</span>
            </a>
        </div>
    </div>;
};

const cmpClass = 'footer-copyright';
const classMap = utils.generateClassMap(cmpClass, {
    container: 'container container',
});
